import React from 'react';

class Address extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.state = {
      address: this.props.project.questionnaire.address,
      town: this.props.project.questionnaire.town,
      postcode: this.props.project.questionnaire.postcode,
    };
  }

  onChange(e) {
    let data = {
      address: this.state.address,
      town: this.state.town,
      postcode: this.state.postcode,
    };

    data[e.target.name] = e.target.value;

    this.props.updateProject({ questionnaire_attributes: data }, formContext => {
      let data = formContext.state;
      data.questionnaire[e.target.name] = e.target.value;
      formContext.setState(data);
    });

    this.setState(data);
  }

  render() {
    return (
      <div className="onboarding-fields">
        <div className="onboarding-fields_label">
          or if you share your full address, we will try and find a plan from open sources and check
          it with you
        </div>
        <div className="clearfix">
          <div className="onboarding-fields_col -w50">
            <input
              className="form-control"
              name="address"
              size="40"
              type="text"
              onChange={this.onChange}
              value={this.state.address}
              placeholder="Address"
            />
          </div>
          <div className="onboarding-fields_col -w25">
            <input
              className="form-control"
              name="town"
              size="20"
              type="text"
              onChange={this.onChange}
              value={this.state.town}
              placeholder="Town"
            />
          </div>
          <div className="onboarding-fields_col -w25">
            <input
              className="form-control"
              name="postcode"
              size="20"
              type="text"
              onChange={this.onChange}
              value={this.state.postcode}
              placeholder="Post code"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Address;



// WEBPACK FOOTER //
// ./app/javascript/components/customer/brief/components/UI/Address.js